import React from 'react';
import PropTypes from 'prop-types';
import { PageNumber } from './atoms';
import { useTheme } from 'styled-components';

export const PagesNavigator = (props) => {
  const { onSelect, currentPage, pagesCount } = props;

  const goToNextPage = () => {
    if (currentPage < pagesCount - 1) {
      onSelect(currentPage + 1);
    }
  }

  const goToPrevPage = () => {
    if (currentPage > 0) {
      onSelect(currentPage - 1);
    }
  }

  const goToFirstPage = () => {
    onSelect(0);
  }

  const goToLastPage = () => {
    onSelect(pagesCount - 1);
  }

  const theme = useTheme();
let hideBackNavigator = () =>{
  if (currentPage==0) {
   return {visibility:'hidden'}
  }else{
    return {visibility:'visible'}
  }
}
const hideForwardNavigator = () =>{
  if (currentPage+1 ==pagesCount) {
   return {visibility:'hidden'}
  }else{
    return {visibility:'visible'}
  }
}

  return (
    <div className="flex items-center">
      <div style={hideBackNavigator()} className='flex items-center'>
      <div className="mr-2.5">
        <svg onClick={goToFirstPage} className="cursor-pointer" width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M7.4375 6.52734L4.4375 3.52734L7.4375 0.527344" stroke={theme?.colour?.primary ?? "#1DBD6B"} strokeLinecap="round" strokeLinejoin="round" />
          <path d="M4 6.52734L1 3.52734L4 0.527344" stroke={theme?.colour?.primary ?? "#1DBD6B"} strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </div>
      <div className="mr-1">
        <svg onClick={goToPrevPage} className="cursor-pointer" width="5" height="8" viewBox="0 0 5 8" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4.49072 6.83984L1.49072 3.83984L4.49072 0.839844" stroke={theme?.colour?.primary ?? "#1DBD6B"} strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </div>
      </div>
      <div className="flex items-center">
        {currentPage > 1 &&
          <PageNumber onClick={() => onSelect(currentPage - 2)}>{currentPage - 1}</PageNumber>
        }
        {currentPage > 0 &&
          <PageNumber onClick={() => onSelect(currentPage - 1)}>{currentPage}</PageNumber>
        }
        <PageNumber selected>{currentPage + 1}</PageNumber>
        {currentPage < pagesCount - 1 &&
          <PageNumber onClick={() => onSelect(currentPage + 1)}>{currentPage + 2}</PageNumber>
        }
        {currentPage < pagesCount - 2 &&
          <PageNumber onClick={() => onSelect(currentPage + 2)}>{currentPage + 3}</PageNumber>
        }
      </div>
      <div style={hideForwardNavigator()} className='flex items-center'>
        <div className="ml-2" >
          <svg onClick={goToNextPage} className="cursor-pointer" width="5" height="8" viewBox="0 0 5 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.6875 0.839844L3.6875 3.83984L0.6875 6.83984" stroke={theme?.colour?.primary ?? "#1DBD6B"} strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>
        <div className="ml-2.5" >
          <svg onClick={goToLastPage} className="cursor-pointer" width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.5 0.839844L3.5 3.83984L0.5 6.83984" stroke={theme?.colour?.primary ?? "#1DBD6B"} strokeLinecap="round" strokeLinejoin="round" />
            <path d="M3.9375 0.839844L6.9375 3.83984L3.9375 6.83984" stroke={theme?.colour?.primary ?? "#1DBD6B"} strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>
      </div>
    </div >
  )
}

PagesNavigator.propTypes = {
  pagesCount: PropTypes.number,
  currentPage: PropTypes.number,
  onSelect: PropTypes.func
};